import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { Category } from './category.model';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {



  constructor(private http: HttpClient, private global: Globle, private localStorage: LocalStorageService) {

  }


  getAll(status: number, directCharge: boolean) {
    return this.http.get<Category[]>(this.global.APIURL + "allcategories?status=" + status + "&directCharge=" + directCharge);
  }

  getById(id: number) {
    return this.http.get<Category>(this.global.APIURL + "category/" + id);
  }

  Create(category: object) {
    return this.http.post(this.global.APIURL + "category", category)
  }

  Update(category: any) {
    return this.http.put(this.global.APIURL + "category", category)
  }

  upload(formdata: any) {
    return this.http.post<any>(this.global.APIURL + "category/upload", formdata)
  }

  Delete(id: number) {
    return this.http.delete(this.global.APIURL + "category/" + id)
  }
}
